<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
  <validation-observer v-slot="{ invalid }">
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <base-material-card color="secondary" :loading="!loaded">
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Edit Profile
            </div>

            <div class="subtitle-1 font-weight-light">
              Complete your profile
            </div>
          </template>
          <v-form v-if="loaded">
            <v-container class="py-0">
              <v-row>
                <v-col align="center">                  
                  <span class="text-center title">MEMBERSHIP DETAILS</span>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="6"
                  md="6"
                >
                  <v-text-field
                    label="Member No"
                    hint="Your Weigh-Less memebership number"
                    type="number"
                    v-model="profile.m"
                  />
                </v-col>
                <v-col
                  cols="6"
                  md="6"
                >
                  <v-text-field
                    label="Group Code"
                    hint="Group code generated by your group leader"
                    type="number"
                    v-model="profile.l"
                  />
                </v-col>

              </v-row>
              <v-row>
                <v-col>                  
                  <p class="text-center title">WEIGHT</p>
                </v-col>
              </v-row>
              <v-row>
                
                <v-col
                  cols="4"
                  md="4"
                >
                  <validation-provider rules="requiredNumeric" v-slot="{ errors }">
                    <v-text-field
                      :error-messages="errors"
                      label="Start"
                      :suffix="profile.u"
                      hint="Weight when you started with Weigh-Less"
                      v-model="profile.w"
                      type="number"
                      name="Start Weight"
                    />
                  </validation-provider>
                </v-col>
                <v-col
                  cols="4"
                  md="4"
                >
                  <validation-provider rules="requiredNumeric" v-slot="{ errors }">
                  <v-text-field
                    :error-messages="errors"
                    label="Current"
                    :suffix="profile.u"
                    type="number"
                    hint="Your last weigh-in weight"
                    v-model="profile.c"
                  />
                  </validation-provider>
                </v-col>
                <v-col
                  cols="4"
                  md="4"
                >
                  <validation-provider rules="requiredNumeric" v-slot="{ errors }">
                  <v-text-field              
                    :error-messages="errors"
                    label="Goal"
                    :suffix="profile.u"
                    type="number"
                    hint="Your goal weight"
                    v-model="profile.g"
                  />
                  </validation-provider>
                </v-col>


              </v-row>
              <v-row>
                <v-col>                  
                  <p class="text-center title">PORTION ALLOWANCE</p>
                </v-col>
              </v-row>
              <v-row>




                <v-col 
                  v-for="portion in orderedPortions"
                  :key="portion.n"
                  cols="4"
                  sm="4"
                  md="2"
                >
                  <validation-provider rules="required|numeric" v-slot="{ errors }">
                  <v-text-field
                    :error-messages="errors"
                    :label="portion.n"
                    type="number"
                    :hint="`Allowance for ${portion.n}`"
                    v-model="portion.a"
                  />
                  </validation-provider>
                </v-col>
               



              </v-row>
              <v-row>
                <v-col>                  
                  <p class="text-center title">STEPS</p>
                </v-col>
              </v-row>
              <v-row>


                <v-col 
                  v-for="step in currentDiet.s"
                  :key="step.n"
                  cols="6"
                  sm="4"
                  md="2"
                >
                  <validation-provider rules="requiredNumeric" v-slot="{ errors }">
                  <v-text-field
                    :error-messages="errors"
                    :label="step.n"
                    type="number"
                    :suffix="profile.u"
                    :hint="`Goal for ${step.n}`"
                    v-model="step.g"
                  />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
          <v-card-actions v-if="loaded">
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="confirmDialog=true" class="mr-0" :loading="saving" :disabled="invalid">
              Save
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>

    <v-dialog
      v-model="confirmDialog"
      max-width="300"
    >
      <v-card>
        <v-card-title>
          Are you sure?
          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="confirmDialog = false"
          >
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="pb-6 pt-12 text-center" v-if="!invalid">
          This will overwrite your existing profile
        </v-card-text>
        <v-card-text class="pb-6 pt-12 text-center error--text" v-if="invalid">
          There are validation errors.  Please correct them before saving.
        </v-card-text>


          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mr-3" text  @click="confirmDialog = false">
              No
            </v-btn>
            <v-btn  color="error" text @click="save" :disabled="invalid">
              Yes
            </v-btn>
          </v-card-actions>

      </v-card>
    </v-dialog>
    <base-material-snackbar
      v-model="showSnackbar"
      :type="error ? 'error' : 'success'"
      top
      center
    >
      <span v-if="error">
        There was an error saving your profile.  Please try again.
      </span>
      <span v-if="success">
        Your profile was saved successfully.
      </span>
    </base-material-snackbar>
  </validation-observer>
  </v-container>
</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex'

  export default {
    data: () => ({
      // eslint-disable-next-line no-unused-labels
      orig_profile: null,
      loaded: false,
      confirmDialog: false
    }),
    computed: {
      ...mapState('Profile', ['profile', 'saving', 'error', 'success','currentDiet']),
      isDirty() {
        // Compare json string of profile with new one.
        return this.orig_profile != JSON.stringify(this.profile);
      },
      orderedPortions() {
        return [...this.currentDiet.g].sort((a, b) => (a.n > b.n) ? 1 : -1)
      },
      showSnackbar: {
        get: function() {
          return this.error || this.success;
        },
        set: function() {
          setTimeout(() => this.clearMessages(), 2000)          
        }
      }
    },
    methods: {
      ...mapActions('Profile', ['saveProfile']),
      ...mapMutations('Profile', ['clearMessages']),
      save() {
        if (!this.invalid) {
          this.confirmDialog = false;
          this.saveProfile();
        }
      },
    },
    mounted: function() {
      this.orig_profile = JSON.stringify(this.profile);
      this.loaded = true;
    }
  }
</script>
